<!-- <app-context-menu *ngIf="!isTTTPaymentPage && tripType !== 'M' && hasStopover == false" title="5/5 Payment" (back)="INDRA_handleBack()" hiddeEdit="true" [isBack]="!confirmedPassengersAndContacts">
    <div class="actions">
        <app-booking-options></app-booking-options>
    </div>
    <div class="steps container space-between">
        <div>
            <h1 class="title-h1 hidden-mobile" skeletonLoader [translationKey]="'contextMenu.text.youAreAlmostDone'">
                {{ 'contextMenu.text.youAreAlmostDone' | ibeadmin | async }}
            </h1>
        </div>
        <app-shopping-cart></app-shopping-cart>
    </div>
</app-context-menu>
<app-context-menu *ngIf="!isTTTPaymentPage && (tripType == 'M' || hasStopover == true)" title="4/4 Payment" (back)="INDRA_handleBack()" hiddeEdit="true" [isBack]="!confirmedPassengersAndContacts">
    <div class="actions">
        <app-booking-options></app-booking-options>
    </div>
    <div class="steps container space-between">
        <div>
            <h1 class="title-h1 hidden-mobile" skeletonLoader [translationKey]="'contextMenu.text.youAreAlmostDone'">
                {{ 'contextMenu.text.youAreAlmostDone' | ibeadmin | async }}
            </h1>
        </div>
        <app-shopping-cart></app-shopping-cart>
    </div>
</app-context-menu>
<app-context-menu *ngIf="isTTTPaymentPage" title="Time to think" (back)="INDRA_handleBack()" [isBack]="!confirmedPassengersAndContacts">
    <div class="actions">
        <app-booking-options></app-booking-options>
    </div>
    <div class="steps container space-between">
        <div>
            <h2 class="title-h2 hidden-mobile">
                <span skeletonLoader [translationKey]="'bookingPayment.title.payment'">
                    {{'bookingPayment.title.payment' | ibeadmin | async}}
                </span>
            </h2>
        </div>
        <app-shopping-cart></app-shopping-cart>
    </div>
</app-context-menu> -->

<app-top-menu-bar [isBack]="!confirmedPassengersAndContacts" (backPage)="INDRA_handleBack()" *ngIf="!INDRA_isTTT() && !isAfterCreatePNR" (newSearch)="INDRA_newSearch()"></app-top-menu-bar>
<app-steps-footer
    [isNonZeroPaymentMethod]="INDRA_isNonZeroPaymentMethod()"
    [isAdyenMethod]="INDRA_isAdyenMethod()"
    [isPaybyrdMethod]="INDRA_isPaybyrdMethod()"
    [isZeroPaymentMethod]="INDRA_isZeroPaymentMethod()"
    [formIsValid]="formIsValid"
    [isButtonPaymentDisableOverride]="isButtonPaymentDisableOverride"
    (confirmPassengersAndContacts)="INDRA_confirmPassengersAndContacts()" 
    (confirmPayment)="INDRA_confirmPayment()"
    (adyenCheckOut)="INDRA_adyenCheckOut()"
    (paybyrdCheckOut)="INDRA_paybyrdCheckOut()"
    (confirmZeroPayment)="INDRA_confirmZeroPayment()"
    [isPaypalPaymentMethod]="selectedPaymentMethod == 'paypal' && !storedOCPPaypal">
</app-steps-footer>
    
<div id="payment-title-section" class="container">
    <ng-container *ngIf="isTTTPaymentPage" title="Time to think">
        <h2 class="title-h2 hidden-mobile">{{'bookingPayment.title.payment' | ibeadmin | async}}</h2>
    </ng-container>

    <ng-container *ngIf="!isTTTPaymentPage">
        <h1 class="payment-page-title">{{ 'contextMenu.text.youAreAlmostDone' | ibeadmin | async }}</h1>
    </ng-container>
	
</div>

<div class="container passenger-warning" *ngIf="INDRA_getAnyManualPassengerEntries() && userData && INDRA_isAwardBooking()">
	<div class="finish-step-note__wrapper">
		<div class="finish-step-note">
			<div>
				<app-svg class="info_icon" svg="icons.svg#general--information"
				[alt]="'Information icon'">
			</app-svg>
			</div>
			<div>
                <p class="warning-title">
                    <span skeletonLoader [translationKey]="'bookingPayment.text.warningOnlyAfterPayment'">
                        {{'bookingPayment.text.warningOnlyAfterPayment' | ibeadmin | async}}, {{ INDRA_buildBenListLabel() }} {{'bookingPayment.text.warningWillJoinBeneficiary' | ibeadmin | async}}.
                    </span>
                </p>
				<span class="finish-step-note_message">
                    <span skeletonLoader [translationKey]="'bookingPayment.text.warningOnlyAfterPaymentBottomText'">
                        {{'bookingPayment.text.warningOnlyAfterPaymentBottomText' | ibeadmin | async}}
                    </span>
                </span>
			</div>
		</div>
	</div>
</div>

<section id="step1" class="step__wrapper step-1 container" [ngClass]="{'is-active': INDRA_getCurrentStep() === 1 || !userInfo, 'is-complete': INDRA_getStatusStep(1).status, 'is-disabled': (INDRA_isDUPE() || INDRA_haveFlighPricesChanged()) && arePaymentMethodsLoaded }"
    [attr.aria-label]="('bookingPayment.aria.yourAccountSection' | ibeadmin | async) + progressiveSteps.length" tabindex="0">

	<div id="step1-container">
		<div *ngIf="INDRA_getStatusStep(1).status && canGo">
			<div class="user-info__wrapper" *ngIf="userInfo">
				<h4>
					<span skeletonLoader [translationKey]="'bookingPayment.text.hello'">
						{{'bookingPayment.text.hello' | ibeadmin | async}}
					</span>,
					{{ userInfo.firstName }} {{ userInfo.lastName }}
				</h4>
				<span skeletonLoader [translationKey]="'bookingPayment.text.youAreLog'">
					{{'bookingPayment.text.youAreLog' | ibeadmin | async}}
				</span>
			</div>
			<div class="user-info__wrapper" *ngIf="!userInfo">
				<span skeletonLoader [translationKey]="'bookingPayment.text.youChoseToContinue'">
					{{'bookingPayment.text.youChoseToContinue' | ibeadmin | async}}
				</span>
			</div>
		</div>
	</div>

</section>


<section id="step2" class="step__wrapper step-2 container" [ngClass]="{'is-active': INDRA_getCurrentStep() === 2 || INDRA_getStatusStep(2).status, 'is-complete': INDRA_getStatusStep(2).status, 'is-disabled': (INDRA_isDUPE() || INDRA_haveFlighPricesChanged()) && arePaymentMethodsLoaded}"
    [attr.aria-label]="('bookingPayment.aria.sectionToInsertPassenger' | ibeadmin | async) + progressiveSteps.length" tabindex="0" *ngIf="canGo">

    <div class="step2-container">
        <div class="progressive-disclosure">
            <div class="progressive-disclosure__content">
                <span class="progressive-disclosure__content--step">
                    <span skeletonLoader [translationKey]="'bookingPayment.text.step'">
                        {{'bookingPayment.text.step' | ibeadmin | async}} <b>2</b> {{'bookingPayment.text.of' | ibeadmin | async}} <b>{{progressiveSteps.length}}</b>
                    </span>
				</span>
                <div class="progressive-disclosure__content--title-wrapper">
                    <app-svg class="progressive-disclosure__icon-check" *ngIf="INDRA_getStatusStep(2).status" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Check icon'">
                    </app-svg>
                    <h3
                        class="progressive-disclosure__content--title title-h3"
                        skeletonLoader
                        [translationKey]="INDRA_getCurrentStep() === 2 ? progressiveSteps[1].label_active : progressiveSteps[1].label"
                    >
                        {{(INDRA_getCurrentStep() === 2 ? progressiveSteps[1].label_active : progressiveSteps[1].label) | ibeadmin | async}}
                    </h3>
                </div>
                <span class="progressive-disclosure__content--subtitle description">
                    <span skeletonLoader [translationKey]="'bookingPayment.text.step'">
                        {{'bookingPayment.text.step' | ibeadmin | async}}
                    </span>
				</span>
            </div>
        </div>
        <div class="container hide-on-print notification--price-change no-padding" *ngIf="INDRA_priceChange()">
            <app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" [title]="'bookingPayment.title.noLongerChild' | ibeadmin | async">
                <div message>
                    <span skeletonLoader [translationKey]="'bookingPayment.text.checkFlightsPriceAgain'">
						{{'bookingPayment.text.checkFlightsPriceAgain' | ibeadmin | async}}
					</span>
                </div>
                <div actions>
                    <button class="button button-black-line" (click)="INDRA_getStatusStep(3).status ? false : INDRA_selectNewFlights()" [attr.aria-label]="'bookingPayment.aria.openSelectFlightsPage' | ibeadmin | async">
                        <span skeletonLoader [translationKey]="'bookingPayment.text.chooseFlightsAgain'">
                            {{'bookingPayment.text.chooseFlightsAgain' | ibeadmin | async}}
                        </span>
					</button>
                </div>
            </app-notification>
        </div>

        <!-- Error message for exceeding name length of adt-inf  -->
        <div class="container hide-on-print notification--price-change no-padding" *ngIf="adtInfExceedsCharLimit.length">
            <app-notification [style]="'alert'" [icon]="'icons.svg#tickets--adult_passenger'" [title]="'bookingPayment.title.nameTooLong' | ibeadmin | async">
                <div message>
                    <span skeletonLoader [translationKey]="'bookingPayment.text.adtInfMaximumChar'">
						{{'bookingPayment.text.adtInfMaximumChar' | ibeadmin | async}}
					</span>
                </div>
            </app-notification>
        </div>
        <div class="passengers_loader_container__overlay" *ngIf="!beneficiaryFlag">
            <div class="loading-wrapper">
                <app-loading></app-loading>
            </div>
        </div>
        <ul #passengersSection class="grid no-padding booking-passenger">
            <li class="col-4 col-tp-6 col-p-12" *ngFor="let passenger of passengers; let i = index">
                <app-passenger *ngIf="beneficiaryFlag" [ngClass]="{'has-warning': INDRA_hasWarning(i)}" [ngStyle]="INDRA_printWarningGaps(i)" [no_detail]="(INDRA_isDUPE() || INDRA_haveFlighPricesChanged()) && arePaymentMethodsLoaded" [no_edit]='confirmedPassengersAndContacts' [pnr]="booked_trip.data.pnr"
                    [flights]="flights" [booked_trip]="booked_trip" [passenger]='passenger' [index]='i' [isBooking]=true [warnings]="passengerWarnings[i]" [isAward]="INDRA_isAwardBooking()">
                </app-passenger>
            </li>
        </ul>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="showVisaBox && !priceChange">
            <div message id="visa-text" class="checkbox-usa">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'visa-check'" [label]="''" (change)="INDRA_visatoUSA()" [checked]="visaToUSA">
                    </app-checkbox-input>
                    <span id="visa-check">
						{{'bookingPayment.text.awareObligation' | ibeadmin | async}}
						<a target="blank_" class="link-visa link" 
							href="https://esta.cbp.dhs.gov/esta/"
							[attr.aria-label]="'bookingPayment.aria.moreInfoObligation' | ibeadmin | async">
							{{'bookingPayment.text.electronicAuthorization' | ibeadmin | async}}
						</a>
						{{'bookingPayment.text.toTravelToUSA' | ibeadmin | async}}
						<a class="link-visa link" 
							(click)="INDRA_gotoURL('externalURLs.travelToUSA')" href="javascript:;"
							[attr.aria-label]="'bookingPayment.aria.moreInfoVisaProgram' | ibeadmin | async">
							{{'bookingPayment.text.visaWaiverProgram' | ibeadmin | async}}
						</a>
					</span>
                </div>
                <div *ngIf="triedToPay && !visaToUSA">
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="isBrazilFlight && !priceChange">
            <div message class="checkbox-br">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'routeInfo-check'" [label]="''" (change)="INDRA_checkedMarket('BR')" [checked]="checkedBR">
                    </app-checkbox-input>
                    <span>
						{{'bookingPayment.text.europeanUnionRules' | ibeadmin | async}}
					</span>
                </div>
                <div *ngIf="triedToPay && !checkedBR" body>
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="isEgyptFlight && !priceChange">
            <div message class="checkbox-eg">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'routeInfo-check'" [label]="''" (change)="INDRA_checkedMarket('EG')" [checked]="checkedEG">
                    </app-checkbox-input>
                    <span>
						{{'bookingPayment.text.necessaryDocumentation1' | ibeadmin | async}}
					</span>
                </div>
                <div *ngIf="triedToPay && !checkedEG" body>
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="isTurkeyFlight  && !priceChange">
            <div message class="checkbox-tr">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'routeInfo-check'" [label]="''" (change)="INDRA_checkedMarket('TR')" [checked]="checkedTR">
                    </app-checkbox-input>
                    <span>
						{{'bookingPayment.text.necessaryDocumentation2' | ibeadmin | async}}
					</span>
                </div>
                <div *ngIf="triedToPay && !checkedTR" body>
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="isChinaFlight && !priceChange">
            <div message class="checkbox-cn">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'routeInfo-check'" [label]="''" (change)="INDRA_checkedMarket('CN')" [checked]="checkedCN">
                    </app-checkbox-input>
                    <span>
						{{'bookingPayment.text.necessaryDocumentation2' | ibeadmin | async}}
					</span>
                </div>
                <div *ngIf="triedToPay && !checkedCN" body>
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="isCanadaFlight && !priceChange">
            <div message class="checkbox-ca">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'routeInfo-check'" [label]="''" (change)="INDRA_checkedMarket('CA')" [checked]="checkedCA">
                    </app-checkbox-input>
                    <span id="visa-check">
						{{'bookingPayment.text.awareObligation' | ibeadmin | async}}
						<a target="blank_" class="link-visa link " 
							href="{{ 'externalURLs.travelToCanada' | ibeadmincfg }}"
							[attr.aria-label]="'bookingPayment.aria.moreInfoObligation' | ibeadmin | async">
							{{'bookingPayment.text.electronicAuthorization' | ibeadmin | async}}
						</a>
						{{'bookingPayment.text.toTravelToCanada' | ibeadmin | async}}
					</span>
                </div>
                <div *ngIf="triedToPay && !checkedCA" body>
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>

        <app-notification [style]="'note'" [title]="'bookingPayment.title.travelDocumentation' | ibeadmin | async" *ngIf="isUnitedKingdomFlight && !priceChange">
            <div message class="checkbox-uk">
                <div class="display--flex">
                    <app-checkbox-input [disabledForm]="confirmedPassengersAndContacts" [attr.aria-labelledby]="'routeInfo-check'" [label]="''" (change)="INDRA_checkedMarket('GB')" [checked]="checkedUK">
                    </app-checkbox-input>
                    <span id="visa-check">
						{{'bookingPayment.text.awareObligation' | ibeadmin | async}}
						<a target="blank_" class="link link--external" 
							href="{{ 'externalURLs.travelToUnitedKingdom' | ibeadmincfg }}"
							[attr.aria-label]="'bookingPayment.aria.moreInfoObligation' | ibeadmin | async">
							{{'bookingPayment.text.electronicAuthorization' | ibeadmin | async}}
						</a>
						{{'bookingPayment.text.toTravelToUnitedKingdom' | ibeadmin | async}}
					</span>
                </div>
                <div *ngIf="triedToPay && !checkedUK" body>
                    <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                </div>
            </div>
        </app-notification>


        <div class="hazmat-box" *ngIf="showHazmatBox && !priceChange">
            <app-notification [style]="'note'" [title]="'bookingPayment.title.useCaution' | ibeadmin | async">
                <div message class="hazmat-text">
                    <span>
						{{'bookingPayment.text.carriageOfProhibitedItems' | ibeadmin | async}}
						<br />
						{{'bookingPayment.text.check' | ibeadmin | async}}
						<a class="hazmat-link link" 
							(click)="INDRA_getStatusStep(3).status ? false : INDRA_hazmatClick()" 
							[attr.aria-label]="'bookingPayment.aria.openSideBarHazmat' | ibeadmin | async" 
							href="javascript:;"
							role="button">
							{{'bookingPayment.text.luggageCannotContain' | ibeadmin | async}}
						</a>
					</span>
                </div>
                <div message class="checkbox-hazmat">
                    <div class="hazmat-info display--flex">
                        <app-checkbox-input [attr.aria-labelledby]="'hazmat-info-check'" [disabledForm]="confirmedPassengersAndContacts" [label]="''" (change)="INDRA_travelHazmat()" [checked]="travelHazmat">
                        </app-checkbox-input>
                        <span id="hazmat-info-check">
							{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}}
							<a class="hazmat-link link" 
								(click)="INDRA_getStatusStep(3).status ? false : INDRA_hazmatClick()" 
								[attr.aria-label]="'bookingPayment.aria.openSideBarHazmat' | ibeadmin | async" 
								href="javascript:;"
								role="button">
								{{'bookingPayment.text.hazmatRestrictions' | ibeadmin | async}}
							</a>
						</span>
                    </div>
                    <div *ngIf="triedToPay && !travelHazmat" body>
                        <span aria-live="polite" class="input-error" role="alert">{{'bookingPayment.text.confirmationIsRequired' | ibeadmin | async}}</span>
                    </div>
                </div>
            </app-notification>
        </div>

        <ng-container *ngIf="(INDRA_getStatusStep(1).status || INDRA_getStatusStep(2).status) && !priceChange">
            <p class="hide-on-print" id="assistance">
                <span skeletonLoader [translationKey]="'bookingPayment.text.specialAssistance'">
                    {{'bookingPayment.text.specialAssistance' | ibeadmin | async}}
                </span>
            </p>
        </ng-container>

        <div class="align-left" *ngIf="showFillFirstAlert && INDRA_getStatusStep(1).status && !INDRA_getStatusStep(2).status && !priceChange">
            <div class="finish-step-note__wrapper">
                <div class="finish-step-note">
                    <app-svg class="finish-step-note__icon" svg="icons.svg#general--information" [alt]="'Information icon'" aria-hidden="true">
                    </app-svg>
                    <span class="finish-step-note_message" skeletonLoader [translationKey]="'bookingPayment.text.youMustAddPassengerDetails'">
						{{'bookingPayment.text.youMustAddPassengerDetails' | ibeadmin | async}}
					</span>
                </div>
            </div>
        </div>
        <div *ngIf="priceChange" class="align-center">
            <button class="button button--big button--fat button--mobile-full top-gap bottom-gap" (click)="INDRA_selectNewFlights()" [attr.aria-label]="'bookingPayment.text.chooseFlightsAgain' | ibeadmin | async">
                <span skeletonLoader [translationKey]="'bookingPayment.text.chooseFlightsAgain'">
                    {{'bookingPayment.text.chooseFlightsAgain' | ibeadmin | async}}
                </span>
			</button>
        </div>
    </div>

</section>


<section *ngIf="!priceChange && canGo && !adtInfExceedsCharLimit.length" id="step3" class="step__wrapper step-3 container" [ngClass]="{'is-active': INDRA_getCurrentStep() === 3 || INDRA_getStatusStep(3).status, 'is-complete': INDRA_getStatusStep(3).status, 'is-disabled': (INDRA_isDUPE() || INDRA_haveFlighPricesChanged()) && arePaymentMethodsLoaded}"
    [attr.aria-label]="('bookingPayment.aria.sectionToInsertContactDetails' | ibeadmin | async) + progressiveSteps.length" tabindex="0">
    <!-- here -->
    <!-- <div class="container gap-top" *ngIf="!isTTTPaymentPage && !userInfo && INDRA_getCurrentStep() < 4 && hasMilesGoDiscount"> -->
    <!--     <app-card-extras-full-width -->
    <!--         [disabled]="INDRA_getStatusStep(3).status" -->
    <!--         [sidebar]="['sign-up']" -->
    <!--         [class]="'sign-up'" -->
    <!--         [info]="'bookingPayment.text.totalPrice' | ibeadmin | async" -->
    <!--         [infoKey]="'bookingPayment.text.totalPrice'" -->
    <!--         [confirmation]="''" -->
    <!--         price="{{ mgpDiscount ? INDRA_displayPrice('discounted') : INDRA_displayPrice('original') }}" -->
    <!--         [label]="'bookingPayment.text.signUp' | ibeadmin | async" -->
    <!--         [labelKey]="'bookingPayment.text.signUp'" -->
    <!--         [isAdded]="false" -->
    <!--          -->
    <!--         [hasExtraInfo]="true" -->
    <!--     > -->
    <!--         <span titleContent skeletonLoader [translationKey]="mgpDiscount ? 'bookingPayment.text.youCanStillSave' : ''"> -->
    <!--             {{ 'bookingPayment.text.youCanStillSave' | ibeadmin | async }} {{ mgpDiscount }} {{ currencyUnit }} {{ 'bookingPayment.text.inThisBooking2' | ibeadmin | async }} -->
    <!--         </span> -->
    <!---->
    <!--         <div extraInfo *ngIf="mgpDiscount; else discountTemplate"> -->
    <!--             <div class='price'> -->
    <!--                 <span class='original-price'> -->
    <!--                     {{ INDRA_getOriginalPrice() }} -->
    <!--                 </span> -->
    <!--                  {{ INDRA_getDiscountedPrice() }} -->
    <!--             </div> -->
    <!--         </div> -->
    <!--         <ng-template extraInfo #discountTemplate> -->
    <!--             <div extraInfo class='price'> -->
    <!--                 {{ INDRA_getOriginalPrice() }} -->
    <!--             </div> -->
    <!--         </ng-template> -->
    <!---->
    <!--         <div description> -->
    <!--             <span skeletonLoader [translationKey]="'bookingPayment.text.login'"> -->
    <!--                 <a class="link" href="javascript:;" role="button" (click)="INDRA_openLogin()" [attr.aria-label]="'bookingPayment.aria.openDialogToLogin' | ibeadmin | async"> -->
    <!--                     {{'bookingPayment.text.login' | ibeadmin | async}} -->
    <!--                 </a> -->
    <!--                 {{'bookingPayment.text.toSaveInThisBooking' | ibeadmin | async}} -->
    <!--             </span> -->
    <!--             <br> -->
    <!--             <span skeletonLoader [translationKey]="'bookingPayment.text.or'"> -->
    <!--                 {{'bookingPayment.text.or' | ibeadmin | async}} -->
    <!--                 <a class="link" href="javascript:;" role="button" (click)="INDRA_signUp()" [attr.aria-label]="'bookingPayment.aria.openDialogToCreateAccount' | ibeadmin | async">  -->
    <!--                     {{'bookingPayment.text.createMilesGoAccount' | ibeadmin | async}}  -->
    <!--                 </a> {{'bookingPayment.text.insertNIF' | ibeadmin | async}} -->
    <!--             </span> -->
    <!--         </div> -->
    <!--     </app-card-extras-full-width> -->
    <!-- </div> -->

    <div class="step3-container">
        <div class="progressive-disclosure">
            <div class="progressive-disclosure__content">
                <span class="progressive-disclosure__content--step">
                    <span skeletonLoader [translationKey]="'bookingPayment.text.step'">
                        {{'bookingPayment.text.step' | ibeadmin | async}} <b>3</b> {{'bookingPayment.text.of' | ibeadmin | async}} <b>{{progressiveSteps.length}}</b>
                    </span>
				</span>

                <div class="progressive-disclosure__content--title-wrapper">
                    <app-svg class="progressive-disclosure__icon-check" *ngIf="INDRA_getStatusStep(3).status" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Check icon'">
                    </app-svg>
                    <h3
                        class="progressive-disclosure__content--title title-h3"
                        skeletonLoader
                        [translationKey]="(INDRA_getCurrentStep() === 3 ? progressiveSteps[2].label_active : progressiveSteps[2].label)"
                    >
                        {{(INDRA_getCurrentStep() === 3 ? progressiveSteps[2].label_active : progressiveSteps[2].label) | ibeadmin | async}}
                    </h3>
                </div>

                <span class="progressive-disclosure__content--subtitle description contact">
                    <span skeletonLoader [translationKey]="'bookingPayment.text.allChangesToThisBooking'">
                        {{'bookingPayment.text.allChangesToThisBooking' | ibeadmin | async}}
                    </span>
                    <br>
                    <span skeletonLoader [translationKey]="'bookingPayment.text.emailAddressWillBeUsed'">
                        {{'bookingPayment.text.emailAddressWillBeUsed' | ibeadmin | async}}
                    </span>
				</span>
            </div>
        </div>

        <ng-container *ngIf="INDRA_getStatusStep(2).status || INDRA_getStatusStep(3).status">
            <div class="grid">
                <app-contact class="col-8 col-tp-12 col-p-12" [no_edit]="confirmedPassengersAndContacts" [pnr]="trip_pnr">
                </app-contact>
            </div>
        </ng-container>

        <div *ngIf="!userInfo && !isTTTBookingForCompletion" class="top-gap">
            <label class="checkbox-wrapper" role="checkbox">
				<input  
					(change)="INDRA_savePassengerContactDetails($event)" 
					[(ngModel)]="hasCookies" 
					type="checkbox" 
					class="checkbox" 
					[attr.disabled]="confirmedPassengersAndContacts ? true : null">
				<span>
                    <label skeletonLoader [translationKey]="'bookingPayment.text.saveAllPassengerDetails'">
                        {{'bookingPayment.text.saveAllPassengerDetails' | ibeadmin | async}}
                    </label>
                </span>
            </label>
        </div>


        <div class="align-left" *ngIf="showFillFirstAlert && INDRA_getStatusStep(2).status && !INDRA_getStatusStep(3).status">
            <div class="finish-step-note__wrapper">
                <div class="finish-step-note">
                    <app-svg class="finish-step-note__icon" svg="icons.svg#general--information" [alt]="'Information icon'" aria-hidden="true">
                    </app-svg>
                    <span class="finish-step-note_message" skeletonLoader [translationKey]="'bookingPayment.text.youMustAddContactDetails'">
                        {{'bookingPayment.text.youMustAddContactDetails' | ibeadmin | async}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- <section class="container confirm-pax-contacts__wrapper" *ngIf="(!confirmedPassengersAndContacts) && INDRA_getCurrentStep() === 4 && !hasPNRCreationError && !hasPaymentStepError && canGo && !adtInfExceedsCharLimit.length">
    <p>
        <span skeletonLoader [translationKey]="'bookingPayment.text.makeSureAllDetailsAreCorrect'">
            {{'bookingPayment.text.makeSureAllDetailsAreCorrect' | ibeadmin | async}}
        </span>
        <br>
        <span skeletonLoader [translationKey]="'bookingPayment.text.wontBeAbleToChange'">
            {{'bookingPayment.text.wontBeAbleToChange' | ibeadmin | async}}
        </span>
    </p>
    <button class="button button-accent button--big button--fat button--mobile-full" (click)="INDRA_confirmPassengersAndContacts()" [attr.aria-label]="'bookingPayment.aria.confirmDetails' | ibeadmin | async" [disabled]="triggerCreatePassenger || triggerCreateContact">
        <span skeletonLoader [translationKey]="'bookingPayment.text.continueToPayment'">
            {{'bookingPayment.text.continueToPayment' | ibeadmin | async}}
        </span>
	</button>
</section> -->

<section *ngIf="(!confirmedPassengersAndContacts) && INDRA_getCurrentStep() === 4 && (hasPNRCreationError || hasPaymentStepError)" class="step__wrapper step-4 dupe" [ngClass]="{'is-active': INDRA_getCurrentStep() === 4, 'is-complete': INDRA_getStatusStep(4).status}"
    [attr.aria-label]="'bookingPayment.aria.bookingErrorSection' | ibeadmin | async" tabindex="0">
    <div class="container" *ngIf="INDRA_haveFlighPricesChanged()">
        <div class="bottom-gap">
            <app-notification [style]="'alert'" [icon]="'icons.svg#interface--undo'" [title]="'bookingPayment.title.flightsPriceChange' | ibeadmin | async">
                <div message>
                    <span skeletonLoader [translationKey]="'bookingPayment.text.sorryChooseFlightsAgain'">
                        {{'bookingPayment.text.sorryChooseFlightsAgain' | ibeadmin | async}}
                    </span>
                </div>
            </app-notification>
        </div>
        <div class="align-center">
            <button class="button" (click)="INDRA_selectNewFlights()" [attr.aria-label]="'bookingPayment.aria.returnToFlightsPage' | ibeadmin | async">
                <span skeletonLoader [translationKey]="'bookingPayment.text.chooseFlightsAgain'">
                    {{'bookingPayment.text.chooseFlightsAgain' | ibeadmin | async}}
                </span>
			</button>
        </div>
    </div>
    <div class="container" *ngIf="hasPNRCreationError">
        <div class="bottom-gap">
            <app-notification [style]="'alert'" [icon]="'icons.svg#general--close'" [titleKey]="'bookingPayment.text.PNRCreationErrorTitle'" [title]="'bookingPayment.text.PNRCreationErrorTitle' | ibeadmin | async">
                <div message>
                    <span skeletonLoader [translationKey]="'bookingPayment.text.PNRCreationError'">
                        {{'bookingPayment.text.PNRCreationError' | ibeadmin | async}}
                    </span>
                </div>
            </app-notification>
        </div>
        <div class="align-center">
            <button 
                class="button" 
                (click)="INDRA_selectNewFlights()" 
                [disabled]="isNavigating || paymentLoading"
                [attr.aria-label]="'bookingPayment.aria.returnToFlightsPage' | ibeadmin | async">
                
                <span *ngIf="!isNavigating" 
                    skeletonLoader 
                    [translationKey]="'bookingPayment.text.newSearch'">
                    {{'bookingPayment.text.newSearch' | ibeadmin | async}}
                </span>
                
                <span *ngIf="isNavigating">
                    {{'bookingPayment.text.loading' | ibeadmin | async}}
                </span>
            </button>
        </div>
    </div>
    <div class="container" *ngIf="hasPaymentStepError">
        <div class="bottom-gap">
            <app-notification [style]="'alert'" [icon]="'icons.svg#general--close'" [titleKey]="'bookingPayment.text.errorInYourBooking'" [title]="'bookingPayment.title.errorInYourBooking' | ibeadmin | async">
                <div message>
                    <span skeletonLoader [translationKey]="'bookingPayment.text.pleaseTryAgainLater'">
                        {{'bookingPayment.text.pleaseTryAgainLater' | ibeadmin | async}}
						<a class="link link--external"
							href="https://www.flytap.com/support/contacts" 
							target="blank_">
							{{'bookingPayment.text.contactTap' | ibeadmin | async}}
						</a> 
						{{'bookingPayment.text.toCompleteBooking' | ibeadmin | async}}
					</span>
                </div>
            </app-notification>
        </div>
        <div class="align-center">
            <button class="button" (click)="INDRA_selectNewFlights()" [attr.aria-label]="'bookingPayment.aria.returnToFlightsPage' | ibeadmin | async">
                <span skeletonLoader [translationKey]="'bookingPayment.text.newSearch'">
                    {{'bookingPayment.text.newSearch' | ibeadmin | async}}
                </span>
			</button>
        </div>
    </div>
</section>

<app-background-icons-animation
    aria-live="polite"
    [attr.aria-label]="'bookingPayment.aria.loadingPaymentMethods' | ibeadmin | async"
    class="top-gap bottom-gap display--block"
    [icons]="loadingPaymentMethodsIcons"
    [title]="'bookingPayment.title.weAreLoadingPaymentMethods' | ibeadmin | async"
    [titleKey]="'bookingPayment.title.weAreLoadingPaymentMethods'"
    [description]="'bookingPayment.text.waitAMoment' | ibeadmin | async"
    [descriptionKey]="'bookingPayment.text.waitAMoment'"
    *ngIf="!arePaymentMethodsLoaded && (!hasPNRCreationError && !hasPaymentStepError) && INDRA_getCurrentStep() === 4 && confirmedPassengersAndContacts"
>
</app-background-icons-animation>

<section *ngIf="INDRA_isDUPE() && arePaymentMethodsLoaded && canGo" class="step__wrapper step-4 dupe" [ngClass]="{'is-active': INDRA_getCurrentStep() === 4, 'is-complete': INDRA_getStatusStep(4).status}" [attr.aria-label]="'bookingPayment.aria.duplicateBookingSection' | ibeadmin | async"
    tabindex="0">
    <div class="container">
        <div class="grid bottom-gap">
            <div class="col-12">
                <app-notification [style]="'alert'" [icon]="'icons.svg#tickets--clone_trip'" [title]="'bookingPayment.title.duplicatedBooking' | ibeadmin | async">
                    <div message>
                        <span>{{'bookingPayment.text.warningIdenticalBooking' | ibeadmin | async}}</span> <br/>
                        <span>{{'bookingPayment.text.continuePreviousBooking' | ibeadmin | async}}</span>
                    </div>
                </app-notification>
            </div>
        </div>
        <div class="grid no-padding">
            <h2 class="title-h1 col-12">{{'bookingPayment.text.bookingYouCanComplete' | ibeadmin | async}}</h2>
            <div *ngFor="let ticket of flight_tickets; trackBy: trackById; let listIndex = index" class="ancillaries-flight col-6 col-tl-6 col-p-12 col-tp-12">
                <app-extras-flight *ngIf="ticket.type === 'flight'" id="{{ ticket.id }}" [flight]="ticket.item" [flight_extras]="ticket.item.extras" [loading_extras]="false" [booked_trip]="dupe_booked_trip" [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']" [upgradeInfo]="false"
                    [editOrChangeInfo]="false" [isDupe]="isDUPE" [extrasAdded]="extrasAdded">
                </app-extras-flight>
            </div>
        </div>

        <app-total-amount-summary [title]="'bookingPayment.title.totalAmountForAllPassengers' | ibeadmin | async" [price]="INDRA_getDupePrice()" [isDupe]="isDUPE"></app-total-amount-summary>

        <hr class="separator" aria-hidden="true">
        <div class="no-padding">
            <div class="dupe__options">
                <p>{{'bookingPayment.text.ifYouDontWantToContinue' | ibeadmin | async}}</p>
                <ul>
                    <li><span>{{'bookingPayment.text.tryAgainIn' | ibeadmin | async}} {{ DUPEdata.controlTimeInMinutes }} {{'bookingPayment.text.minutes' | ibeadmin | async}}</span></li>
                    <li><span>{{'bookingPayment.text.startANewSearch' | ibeadmin | async}}</span></li>
                </ul>
            </div>
            <div class="dupe__actions">
                <div>
                    <button class="button button--fat button-black-line button--mobile-full" (click)="INDRA_selectNewFlights()" [attr.aria-label]="'bookingPayment.aria.goToFirstPage' | ibeadmin | async">
						{{'bookingPayment.text.newSearch' | ibeadmin | async}}
					</button>
                </div>
                <div class="align-right">
                    <button class="button button--fat button-accent button--mobile-full" (click)="INDRA_handleDUPE()" [attr.aria-label]="'bookingPayment.aria.goToPaymentSection' | ibeadmin | async">
						{{'bookingPayment.text.continueWithThisBooking' | ibeadmin | async}}
					</button>
                </div>
            </div>
        </div>

    </div>
</section>



<section *ngIf="!INDRA_isDUPE() && !INDRA_haveFlighPricesChanged() && arePaymentMethodsLoaded && !hasPNRCreationError && !hasPaymentStepError && INDRA_getCurrentStep() === 4 && canGo && !differentTTTMarket" id="step4" class="step__wrapper step-4 step-payment container" [ngClass]="{'is-active': INDRA_getCurrentStep() === 4, 'is-complete': INDRA_getStatusStep(4).status}"
    [attr.aria-label]="('bookingPayment.aria.sectionToPay' | ibeadmin | async) + progressiveSteps.length" tabindex="0">

    <div class="step4-container">

        <div class="progressive-disclosure">
            <div class="progressive-disclosure__content">
                <span class="progressive-disclosure__content--step">
					{{'bookingPayment.text.step' | ibeadmin | async}} <b>4</b> {{'bookingPayment.text.of' | ibeadmin | async}} <b>{{progressiveSteps.length}}</b>
				</span>
                <div class="progressive-disclosure__content--title-wrapper">
                    <app-svg class="progressive-disclosure__icon-check" *ngIf="INDRA_getStatusStep(4).status" svg="icons.svg#general--check_big" aria-hidden="true" [alt]="'Check icon'">
                    </app-svg>
                    <h3 class="progressive-disclosure__content--title title-h3">
                        {{(INDRA_getCurrentStep() === 4 ? progressiveSteps[3].label_active : progressiveSteps[3].label) | ibeadmin | async}}
                    </h3>
                </div>
            </div>
        </div>

        <ng-container *ngIf="hasUpdatedFlightPrices && !isTTTBookingForCompletion">
            <app-notification class="bottom-gap display--block" [style]="'note'" [icon]="'icons.svg#money_related--discount'" [title]="'bookingPayment.title.pricesHaveBeenUpdated' | ibeadmin | async">
                <div message>
                    <span *ngIf="paxTierListString">
						{{'bookingPayment.text.oneOrMorePassengersAreMember' | ibeadmin | async}} {{paxTierListString}} {{'bookingPayment.text.oneOrMorePassengersAreMember2' | ibeadmin | async}}
					</span> <br />
                    <span>
						{{'bookingPayment.text.pleaseCheckNewPricesBelow' | ibeadmin | async}}
						<a (click)="INDRA_handlePriceBreakDown()" class="link"
							href="javascript:;" role="button" 
							[attr.aria-label]="'bookingPayment.aria.openPriceBreakdown' | ibeadmin | async">
							{{'bookingPayment.text.seeCompletePriceBreakdown' | ibeadmin | async}}
						</a>
					</span>
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="hasCreateAncillariesError">
            <app-notification class="bottom-gap display--block" [style]="'alert'" [icon]="'icons.svg#general--close'" [title]="'bookingPayment.text.ancillariesErrorTitle' | ibeadmin | async">
                <div message>
                    <span>
						{{'bookingPayment.text.ancillariesErrorMessage' | ibeadmin | async}}
					</span>
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="ancillariesRemoved && ancillariesRemoved.length > 0">
            <app-notification class="bottom-gap display--block" [style]="'alert'" [icon]="'icons.svg#general--close'" [title]="'bookingPayment.text.bundleSelectedChanges' | ibeadmin | async">
                <div message>
                    <span>{{'bookingPayment.text.bundleIncludesAncillariesLoyalty' | ibeadmin | async}}</span><br>
                    <span>{{'bookingPayment.text.addAncillaryLater' | ibeadmin | async}}</span><br>
                    <span>{{'bookingPayment.text.checkNewPricesBelow' | ibeadmin | async}} </span>
                    <a (click)="INDRA_handlePriceBreakDown()" class="link" href="javascript:;" role="button"
                        [attr.aria-label]="'bookingPayment.aria.openPriceBreakdown' | ibeadmin | async">{{'bookingPayment.text.seeCompletePriceBreakdown' | ibeadmin | async}}
                    </a>
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="INDRA_getStatusStep(3).status">
            <!-- note: this price section is for normal payment and payment of previously purchased TTT booking -->
            <div class="payment-table" *ngIf="isBookingPaymentPage">
                <div class="payment-table__body" role="list" [attr.aria-label]="'bookingPayment.aria.whatYouPurchased' | ibeadmin | async">
                    <div class="payment-table__line" role="listitem" *ngFor="let item of items_summary;">
                        <div class="payment-table__cell">
                            {{ item.label | ibeadmin | async }}

                            <ng-container *ngIf="item.includedAncillaries && item.includedAncillaries.length > 0">
                                <ng-container *ngFor="let includedAncillary of item.includedAncillaries; index as i">
                                    {{ getAncillaryLabelTranslation(includedAncillary) | ibeadmin | async }}
                                    <ng-container *ngIf="i < item.includedAncillaries.length - 1">
                                        +
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <a *ngIf="item.type === 'flight'" (click)="INDRA_handlePriceBreakDown()" class="text-link" href="javascript:;" role="button" [attr.aria-label]="'bookingPayment.aria.openPriceBreakdown' | ibeadmin | async">
								{{'bookingPayment.text.details' | ibeadmin | async}}
							</a>
                        </div>
                        <div class="payment-table__cell">
                            <ng-container *ngIf="item.payWithMiles; else cashOnly">
                                <span class="updated-price-tag" *ngIf="item.discounted && !isTTTBookingForCompletion">
									{{'bookingPayment.text.newPrice' | ibeadmin | async}}
								</span>
                                <span class="line-through">
									{{ item.oldValue | indracurrency }}
								</span> {{ item.miles | indracurrency: 'M' }}
                            </ng-container>
                            <ng-template #cashOnly>
                                <ng-container *ngIf="item.discounted && !isTTTBookingForCompletion">
                                    <span class="updated-price-tag">
										{{'bookingPayment.text.newPrice' | ibeadmin | async}}
									</span>
                                    <span class="line-through">
										{{ item.oldValue | indracurrency }}
									</span>
                                </ng-container>
                                {{ item.value | indracurrency }}
                            </ng-template>
                        </div>
                    </div>
                    <!-- Credit card surcharge -->
                    <div class="payment-table__line" role="listitem" *ngIf="!this.isZeroCashPayment && surchargeAmount > 0">
                        <div class="payment-table__cell">{{ 'bookingPayment.text.surcharge' | ibeadmin | async }}</div>
                        <div class="payment-table__cell">
                            {{ INDRA_printCreditCardSurchargeAmount() | indracurrency }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- note: this price section is for payment to avail a TTT booking -->
            <div class="payment-table" *ngIf="isTTTPaymentPage">
                <div class="payment-table__body" role="list" [attr.aria-label]="'bookingPayment.aria.whatYouPurchased' | ibeadmin | async">
                    <div class="payment-table__line no-margin" role="listitem" *ngFor="let item of items_summary;">
                        <div class="payment-table__cell">
                            {{ item.label | ibeadmin | async }}

                            <ng-container *ngIf="item.includedAncillaries && item.includedAncillaries.length > 0">
                                <ng-container *ngFor="let includedAncillary of item.includedAncillaries; index as i">
                                    {{ getAncillaryLabelTranslation(includedAncillary) | ibeadmin | async }}
                                    <ng-container *ngIf="i < item.includedAncillaries.length - 1">
                                        +
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="payment-table__cell">
                            {{ item.value | indracurrency}}
                        </div>
                    </div>
                </div>
                <h5 class="label">
                    {{'bookingPayment.text.totalToPayNow' | ibeadmin | async}}
                </h5>
                <div class="payment-table__line no-margin" role="listitem">
                    <div class="payment-table__cell">{{'bookingPayment.text.total' | ibeadmin | async}}</div>
                    <div class="payment-table__cell">
                        {{ INDRA_printTotalPrice() | indracurrency }}
                    </div>
                </div>
            </div>
            <!-- <div class="vouchers-or-promocodes__wrapper top-gap" [class.disabled-div]="isHPPRedFlagEnabled" *ngIf="!isTTTPaymentPage">
                <app-svg aria-hidden="true" [alt]="'Discount icon'" class="voucher__content_icon" svg="sprite.svg#status--discount"></app-svg>
                <div class="vouchers-or-promocodes__text">
                    <a href="javascript:;" role="button" class="link display--block" (click)="INDRA_handleVoucherOrPromocode()" [attr.aria-label]="'bookingPayment.aria.openVouchers' | ibeadmin | async">
						{{ (promoCodesAndVoucher.length === 0 ? 'bookingPayment.text.addGiftVoucher' : 'bookingPayment.text.manageGiftVoucher' ) | ibeadmin | async   }}
					</a>
                    <span class="vouchers-or-promocodes__description">
						{{ 'voucherPromocodeSidebar.text.redeemPromocodeOrVoucher' | ibeadmin | async }}
					</span>
                </div>
            </div> -->

            <ng-container *ngIf="hasMilesDiscount && !isTTTPaymentPage">
                <!-- <app-notification [style]="'alert'" [title]="'voucherPromocodeSidebar.title.sorryItsNotPossible' | ibeadmin | async" [icon]="'icons.svg#miles_and_go--manage_miles'">
                    <div message>
                        <span>{{'voucherPromocodeSidebar.text.youCanUseEither' | ibeadmin | async}} 
                        <span class="bold">{{'voucherPromocodeSidebar.text.voucherPromocodes' | ibeadmin | async}}</span> {{'voucherPromocodeSidebar.text.or' | ibeadmin | async}}
                        <span class="bold">{{'voucherPromocodeSidebar.text.miles' | ibeadmin | async}}</span>. {{'voucherPromocodeSidebar.text.please' | ibeadmin | async}}
                        <a [attr.aria-label]="'voucherPromocodeSidebar.aria.removeMiles' | ibeadmin | async" class="link link--dark" href="javascript:;" role="button" (click)="sliderComponent.INDRA_changeMiles(0)">{{'voucherPromocodeSidebar.text.removeMiles' | ibeadmin | async}}</a>                            {{'voucherPromocodeSidebar.text.ifYouWantToAdd' | ibeadmin | async}}
                        </span>
                    </div>
                </app-notification> -->

                <div class="top-gap bottom-gap">                
                    <a class="link" [class.disabled-div]="isHPPRedFlagEnabled" (click)="INDRA_handleVoucherOrPromocode()" [attr.aria-label]="'priceBreakdown.aria.addManagePromocode' | ibeadmin | async" href="javascript:;" role="button">
                        <span *ngIf="promoCodesAndVoucher && promoCodesAndVoucher.length > 0">
                            {{ 'priceBreakdown.link.manageVoucherOrPromocodes' | ibeadmin | async }}
                        </span>
                        <span *ngIf="!promoCodesAndVoucher || !promoCodesAndVoucher.length || promoCodesAndVoucher.length === 0">
                            {{ 'priceBreakdown.link.addVoucherOrPromocode' | ibeadmin | async }}
                        </span>
                    </a>

                </div>
            </ng-container>


            <div class="options__wrapper col-12 grid details-block has-details" [class.disabled-div]="isHPPRedFlagEnabled || useMilesDisabled" *ngIf="!hasMilesDiscount && !isTTTPaymentPage ">
				<fieldset class="col-12 col-tl-12 col-tp-12 col-p-12">
					<div class="voucher-or-promocode">
						<div id="icon_column" *ngIf="!loading">
							<app-svg [alt]="'Discount icon'" aria-hidden="true"
								class="voucher-or-promocode__content_icon" svg="sprite.svg#status--discount"></app-svg>
						</div>
						<div id="voucher-or-promocode_section">
                            <ng-container>
                                <app-loading-shadow class="bottom-gap" *ngIf="loading" [height]="'10rem'"></app-loading-shadow>
                            </ng-container>
                            <div class="voucher-or-promocode__content">
                                <ng-container *ngIf="discounts.length && !loading">
                                    <div *ngFor="let discount of discounts; let i = index">
                                        <div class="voucher-or-promocode__content__list">
                                            <div class="voucher-or-promocode__content_label">
                                                <div>
                                                    <p class="title-h6">{{ 'bookingSearch.label.discountApplied' | ibeadmin | async }}</p>
                                                    <p class="title-h6">{{ discount.code }}</p>
                                                    <span class="voucher-or-promocode__content_description">
                                                        
                                                        <p class="italic" *ngIf="discount.type === 'voucher'" aria-live="polite">
															{{ 'bookingSearch.label.voucherApplied' | ibeadmin | async }} {{ discount.amount }}
															{{ discount.currencyCode }} {{ 'bookingSearch.label.inThisBooking' | ibeadmin | async }}
                                                            <a title="{{ 'bookingSearch.label.removeVoucher' | ibeadmin | async }}" [attr.aria-label]="'bookingSearcharia.removeVoucher' | ibeadmin | async" class="link voucher-or-promocode__content_remove" (click)="INDRA_removeDiscount( discount, i )" href="javascript:;" role="button">
                                                                {{ 'bookingSearch.text.removeVoucher' | ibeadmin | async }} {{ discount.type }}
                                                            </a>
														</p>

                                                        <p *ngIf="discount.type === 'promocode'">
                                                            {{ 'bookingSearch.text.payLess' | ibeadmin | async }}
                                                            <span class="bold" *ngIf="discount.amountType === FIXED_DISCOUNT">
                                                                {{ discount.amount }} {{ discount.currencyCode }}
                                                            </span>
                                                            <span class="bold" *ngIf="discount.amountType === PERCENTAGE_DISCOUNT">
                                                                {{ discount.amount + '%'}}
                                                            </span> {{ 'bookingSearch.text.forThisBooking' | ibeadmin | async }}
                                                            <a title="{{ 'bookingSearch.label.removeVoucher' | ibeadmin | async }}" [attr.aria-label]="'bookingSearch.aria.removeVoucher' | ibeadmin | async" class="link voucher-or-promocode__content_remove" (click)="INDRA_removeDiscount(discount, i )" href="javascript:;" role="button">
                                                                {{ 'bookingSearch.text.removeVoucher' | ibeadmin | async }} {{ discount.type }}
                                                            </a>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="voucher-or-promocode__content_amounts" *ngIf="discount.type === 'voucher'">
                                                <p class="amount_subtitle">in Voucher</p>
                                                <div class="voucher-or-promocode__content_amounts_total">
                                                    <app-svg [alt]="'Discount icon'" aria-hidden="true"
                                                        class="voucher-or-promocode__content_amounts_icon"
                                                        svg="sprite.svg#status--discount"></app-svg>
                                                    <h6 class="title-h6">
                                                        {{ discount.actualValue }} {{ discount.currencyCode }}
                                                    </h6>
                                                </div>
                                                <p class="value_selected">{{ discount.amount }} {{environment.currency.label}}</p>
                                            </div>
                                        </div>  
                                        <hr class="separator" aria-hidden="true" *ngIf="discounts.length <= 3">  
                                    </div>
                                    
                                </ng-container>
                            </div>
                            <div class="voucher-or-promocode__vouchers" *ngIf="!loading">
                                <div id="formHeader">
                                    <ng-container *ngIf="(!discounts.length && !isQuantityStage) || (showFormAdd && !isQuantityStage)">
                                        <div>
                                            <div class="voucher-or-promocode__content_label">
                                                <span class="title-h6">
                                                     {{ 'bookingSearch.label.promocode' | ibeadmin | async }}
                                                 </span>
                                             </div>
                                             <span class="voucher-or-promocode__content_description">
                                                 <p> {{ 'bookingSearch.text.promocode' | ibeadmin | async }}</p>
                                             </span>
                                        </div> 
                                    </ng-container>
        
                                    <ng-container *ngIf="isQuantityStage && showFormAdd">
                                        <div>
                                            <div class="voucher-or-promocode__content_label">
                                                <span class="title-h6"> {{ 'bookingSearch.label.promocode' | ibeadmin | async }} </span>
                                            </div>
                                            <span class="voucher-or-promocode__content_description">
                                                <p>{{ 'bookingSearch.text.promocode' | ibeadmin | async }}</p> 
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
    
                                <form class="voucher-or-promocode__form" [formGroup]="formAdd" (ngSubmit)="INDRA_addVoucher()"
                                 *ngIf="showFormAdd || discounts.length === 0" [ngStyle]="{'margin-top': isQuantityStage == 'quantity' ? '0' : '15px' }">
                                    <div class="form-field--row grid no-padding">
        
                                        <div class="form-field col-3 col-tl-3 col-tp-3 col-p-12" *ngIf="!isQuantityStage">
                                            <input aria-label="'bookingSearch.aria.validatingVoucherPromo' | ibeadmin | async" maxlength="20" [attr.disabled]="validatingVoucherPromocode ? true : null" class="input-text" formControlName="promocode" id="promocode-or-voucher" [value]="inputCode" (input)="INDRA_valuechange($event.target.value)" />
                                            <span class="input-error" role="alert" aria-live="polite" *ngIf="INDRA_hasErrors">
                                                {{ INDRA_hasErrors }}
                                            </span>
                                        </div>
        
                                        <div class="form-field col-3 col-tl-3 col-tp-3 col-p-12" *ngIf="isVoucher && !isQuantityStage">
                                           <input [attr.disabled]="validatingVoucherPromocode ? true : null" name="email" id="promocode-or-voucher-email" formControlName="promocodeemail" placeholder="{{'voucherPromocodeSidebar.placeholder.insertVoucherEmail' | ibeadmin | async}}" class="input-text" />
                                        </div>

                                        <div class="form-field col-3 col-tl-3 col-tp-3 col-p-12" *ngIf="isVoucher && !isQuantityStage && showVoucherPin">
                                            <input [attr.disabled]="validatingVoucherPromocode ? true : null" id="promocode-or-voucher-pin" formControlName="promocodepin" placeholder="{{'voucherPromocodeSidebar.placeholder.insertVoucherPin' | ibeadmin | async}}" class="input-text" />
                                            <span class="input-error" role="alert" aria-live="polite" *ngIf="INDRA_hasPinErrors; else pinInfo">
                                                {{ INDRA_hasPinErrors }}
                                            </span>
                                            <ng-template #pinInfo>
                                                <span class="voucher-or-promocode__content_description">
                                                    {{ 'voucherPromocodeSidebar.text.weSentYouAPin' | ibeadmin | async }}
                                                    {{ 'voucherPromocodeSidebar.text.pleaseCheckYourInbox' | ibeadmin | async }}
                                                </span>
                                            </ng-template>
                                         </div>
                                        
                                        <div class="col-12 col-tl-12 col-tp-12 col-p-12" id="quantity_section" *ngIf="isQuantityStage && allowPartialBalance">
                                            <div id="quantity_row">
                                                <div id="quantity_radio">
                                                    <app-radio-input-group
                                                        (optionChanged)="INDRA_selectVoucher($event)"
                                                        label=""
                                                        name="voucherOptions"
                                                        [options]="[
                                                            {
                                                                id: 'total',
                                                                selected: false,
                                                                label: INDRA_getTranslation('bookingSearch.voucherOptions.total')
                                                            },
                                                            {
                                                                id: 'partial',
                                                                selected: false,
                                                                label: INDRA_getTranslation('bookingSearch.voucherOptions.partial')
                                                            }
                                                    ]">
                                                    </app-radio-input-group>
                                                </div>
                                                <div class="voucher-or-promocode__actions" id="quantity_partial">
                                                    <div id="quantity_partial_actions">
                                                        <div id="quantity_text_box" *ngIf="isPartialSelected != false">
                                                            <input aria-label="Insert amount" class="input-text"
                                                                type="number"
                                                                placeholder="{{ currentVoucherCurrency }}"
                                                                formControlName="quantity"
                                                                id="promocode-or-voucher-quantity"
                                                                (input)="INDRA_getValue($event.target.value)" />
                                                        </div>
                                                        <div id="quantity_button_box" *ngIf="showDiscountButton">
                                                            <button class="button"
                                                                (click)="INDRA_useDiscount($event)">
                                                                Use Discount
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="quantity_error_box" *ngIf="INDRA_hasQErrors">
												<span class="input-error" role="alert" aria-live="polite"
													[ngStyle]="{'width': isPartialSelected != undefined ? setErrorWidth() : '0px' }">
													{{ INDRA_hasQErrors }}
												</span> 
											</div>
                                        </div>                                
    
                                        <div class="form-field col-3 col-tl-3 col-tp-3 col-p-12">
                                            <div class="voucher-or-promocode__actions">
                                                <button *ngIf="!isQuantityStage" [attr.disabled]="validatingVoucherPromocode ? true : null" class="button" aria-label="'bookingSearch.button.promoOrVoucher' | ibeadmin | async">
                                                    {{ 'bookingSearch.button.promoOrVoucher' | ibeadmin | async }}
                                                </button>
        
                                                <app-loading-circle class="voucher-or-promocode__loading" *ngIf="validatingVoucherPromocode" role="alert" aria-live="polite" aria-label="'bookingSearch.aria.validatingVoucherPromo' | ibeadmin | async">
                                                </app-loading-circle>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <a aria-label="'bookingSearch.button.promoOrVoucher' | ibeadmin | async'" class="link link--external" target="_blank" (click)="INDRA_redirectToUrl('externalURLs.voucherTermsUrl')" href="javascript:;" role="button">
                                       {{ 'bookingSearch.text.voucherAndPromoCodeTerms' | ibeadmin | async }}
                                    </a> -->
                                </form>

                                <div id="add-another-voucher-container"
                                    *ngIf="discounts.length < 3 && discounts.length !== 0 && !showFormAdd">
                                    <a class="link add-another-voucher" id="add-another-voucher-container" aria-label="'bookingSearch.button.addAnotherVoucher' | ibeadmin | async'" (click)="INDRA_addAnotherVoucher()" href="javascript:;" role="button">
                                        {{ 'bookingSearch.button.addAnotherVoucher' | ibeadmin | async }}
                                    </a>
                                </div>
                                
                                <div class="voucher-or-promocode__message-wrapper" *ngIf="discounts.length >= 3">
                                    <app-svg class="voucher-or-promocode__icon" svg="icons.svg#general--information" aria-hidden="true" [alt]="'bookingSearch.alt.informationIcon' | ibeadmin | async"></app-svg>
                                    <span class="voucher-or-promocode__message">
                                        {{ 'bookingSearch.errorMessage.cantAddVouchers' | ibeadmin | async }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        
					</div>
				</fieldset>
			</div>

            <div class="container" *ngIf="showError">
                <app-notification [style]="'error'" [title]="''">
                    <div message>
                        <span skeletonLoader [translationKey]="'review.text.couldNotRemoveCarbon'">
                            {{ 'review.text.couldNotRemoveCarbon' | ibeadmin:'':false | async }}
                        </span>
                    </div>
                </app-notification>
            </div>

			<div class="carbon-offset-test" *ngIf="INDRA_showCarbon()">
                <app-card-extras-full-width
                    [sidebar]="['carbon-offset']"
                    [classes]="'carbon-offset'"
                    [className]="'carbon-offset'"
                    [title]="'review.cardExtras.text.addressYourCarbonFootprint' | ibeadmin | async"
                    [titleKey]="'review.cardExtras.text.addressYourCarbonFootprint'"
                    [description]="'review.cardExtras.text.offsetYourCarbon' | ibeadmin:'':false | async"
                    [descriptionKey]="'review.cardExtras.text.offsetYourCarbon'"
                    [logoFilename]="'icons.svg#plane_related--world_carbon'"
                    [info]="'<b>' + INDRA_formatCashPrice(carbonBundle.carbonOffsetProperties.totalForAllPassenger) + ' ' + carbonBundlecurrency + '</b> ' + ('review.cardExtras.text.perBooking' | ibeadmin | async)"
                    [infoKey]="'review.cardExtras.text.perBooking'"
                    [confirmation]="'review.cardExtras.text.edit' | ibeadmin | async"
                    [confirmationKey]="'review.cardExtras.text.edit'"
                    [price]="carbonBundle.carbonOffsetProperties.totalForAllPassenger.toFixed(2) + ' ' + carbonBundlecurrency"
                    [closeButton]='false'
                    [label]="'review.cardExtras.text.addCarbonOffset' | ibeadmin | async"
                    [labelKey]="'review.cardExtras.text.addCarbonOffset'"
                    [isAdded]="booked_trip?.carbon_offset" (isShowError)="INDRA_showError($event)"
                >
                </app-card-extras-full-width>
			</div>

            <section *ngIf="(INDRA_hasAncillaries() || INDRA_isFlightApplicableForMGP()) && isBookingPaymentPage && userInfo">
                <div class="miles-payment-container">
                    <div class="miles-payment-container__info">
                        <h2 class="title-h2 title-confirmation">{{'bookingPayment.text.useMilesToPay' | ibeadmin | async}}</h2>

                        <div class="miles-subtitle-info__wrapper" *ngIf="userInfo && isUserMGPClient && userMiles >= 0 ">
                            <span class="miles-subtitle-info">{{'bookingPayment.text.youHaveABalance' | ibeadmin | async}} <span class="bold">{{INDRA_userMiles() | indracurrency: 'M'}}</span> {{'bookingPayment.text.miles' | ibeadmin | async}}<span *ngIf="userInfo.miles >= convertedMgpDiscount">, {{'bookingPayment.text.youCanUseInThisTrip' | ibeadmin | async}}</span>.
                            <a class="link" [attr.aria-label]="'bookingPayment.text.learnMoreOpenWindow' | ibeadmin | async" href="javascript:;" (click)="INDRA_openLearnMoreMiles()">{{'bookingPayment.text.learnMore' | ibeadmin | async}}</a></span>
                            <span class="miles-subtitle-info miles-subtitle-info--balance" *ngIf="INDRA_isFlightApplicableForMGP()">
								{{'bookingPayment.text.yourTotalBalance' | ibeadmin | async}}
								<app-loading-circle class="miles-subtitle-info--loading" *ngIf="(loading$ |async)"></app-loading-circle>
								<span class="bold" [ngClass]="{'is-loading': (loading$ |async) }">{{INDRA_milesBalance() | indracurrency: 'M'}}</span>
                            </span>
                        </div>

                        <span class="miles-subtitle-info" *ngIf="userInfo && !isUserMGPClient">
							<a class="link" [attr.aria-label]="'bookingPayment.aria.openDialogToUpgradeAccount' | ibeadmin | async" href="javascript:;"
								(click)="INDRA_openUpgradeAccount()">{{'bookingPayment.text.upgrade' | ibeadmin | async}}</a> {{'bookingPayment.text.toUseMiles' | ibeadmin | async}} <a class="link" [attr.aria-label]="'bookingPayment.text.learnMoreOpenWindow' | ibeadmin | async"
								href="javascript:;" (click)="INDRA_openLearnMoreMiles()">{{'bookingPayment.text.learnMore' | ibeadmin | async}}</a>
						</span>
                    </div>
                    <div class="miles-payment-container__extras" *ngIf="INDRA_hasAncillaries()">
                        <app-payment-extras-miles [ancillaryList]="INDRA_getAncillariesPayableByMiles()" (hasAPIError)="INDRA_callCheckPaymentMethod($event)"></app-payment-extras-miles>
                    </div>
                    <div class="miles-payment-container__flights" [class.disabled-div]="isHPPRedFlagEnabled || useMilesDisabled" *ngIf="INDRA_isFlightApplicableForMGP() && userInfo">
                        <app-miles-slider-control [variation]="'payment'"></app-miles-slider-control>
                    </div>
                </div>
            </section>

            <app-cardless [cardlessToken]="cardlessToken" *ngIf="cardlessEnabled"></app-cardless>

            <app-total-amount-summary *ngIf="isBookingPaymentPage" [title]="'bookingPayment.text.totalToPayNow' | ibeadmin | async" [isTTTBookingForCompletion]="isTTTBookingForCompletion" [isBookingAreadyCreated]="true" [pnr]="trip_pnr">
            </app-total-amount-summary>

            <ng-container *ngIf="isZeroCashPayment">
                <ng-container *ngIf="hasVoucherErrorFlag1">
                    <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.alertErrorVoucher1' | ibeadmin | async}}">
                        <div message>
                            {{'shoppingBasket.text.alertErrorVoucher1' | ibeadmin | async}}
                        </div>
                    </app-notification>
                </ng-container>

                <ng-container *ngIf="hasVoucherErrorFlag2">
                    <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.alertErrorVoucher2' | ibeadmin | async}}">
                        <div message>
                            <span>{{'shoppingBasket.text.alertErrorVoucher2A' | ibeadmin | async}}</span><br />
                            <span>{{'shoppingBasket.text.alertErrorVoucher2B' | ibeadmin | async}}</span>
                        </div>
                    </app-notification>
                </ng-container>
            </ng-container>

            <div class="payment-table" *ngIf="hasPartnerExtras && isBookingPaymentPage">
                <div class="payment-table__body" [attr.aria-label]="'bookingPayment.aria.linkExtrasToPay' | ibeadmin | async">
                    <div class="payment-table__line" role="listitem">
                        <div class="payment-table__cell">
                            {{'bookingPayment.text.extrasToPay' | ibeadmin | async}}
                        </div>
                        <div class="payment-table__cell">
                            <a (click)="INDRA_handlePriceBreakDown()" class="link" href="javascript:;" role="button">
									{{'bookingPayment.text.seeExtras' | ibeadmin | async}}
								</a>
                        </div>
                    </div>
                </div>
            </div>

            <app-notification class="discount-notification" [style]="'note'" [icon]="'icons.svg#general--information'" *ngIf="INDRA_showVoucherNotification()">
                <div message>
                    <span>
						{{'bookingPayment.text.discountExceeds' | ibeadmin | async}}
					</span>
                    <span>
						{{'bookingPayment.text.checkThe' | ibeadmin | async}}
						<a class="link link--external" 
							(click)="INDRA_gotoURL('externalURLs.voucherTermsAndCondition')" href="javascript:;"
							[attr.aria-label]="'bookingPayment.aria.termsAndConditions' | ibeadmin | async">
							{{'bookingPayment.text.termsAndConditions' | ibeadmin | async}}
						</a>
					</span>
                </div>
            </app-notification>
            <app-notification class="discount-notification" [style]="'note'" [icon]="'icons.svg#general--information'" *ngIf="INDRA_showVoucherNotification()">
                <div message>
                    <span>
						{{'bookingPayment.text.vouchersCannotBeUsed' | ibeadmin | async}}
					</span>
                </div>
            </app-notification>

        </ng-container>

    </div>

    <section class="container payment-method-section" *ngIf="INDRA_getStatusStep(3).status && !INDRA_isZeroCashPayment()">

        <div class="title no-margin-bottom top-gap--tablet-up" *ngIf="!INDRA_isZeroCashPayment() && !isPaybyrdEnabled">
            <h2 class="title-h2">{{'bookingPayment.text.selectPaymentMethod' | ibeadmin | async}}</h2>
        </div>

        <!-- payment method count error message -->
        <ng-container *ngIf="hasFOPCountError">
            <app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" title="{{ (isZeroCashPayment ? 'bookingPayment.title.exceedFOPCountMessage' : 'bookingPayment.title.fopFullBasketAmountError') | ibeadmin | async}}">
                <div message>
                    <span>
						{{ 'bookingPayment.text.fopCountMessage' | ibeadmin | async }}
						<a (click)="INDRA_handleVoucherOrPromocode()" class="link" href="javascript:;" role="button">
							{{ 'bookingPayment.text.removeVoucherPromocode' | ibeadmin | async }}
						</a>
					</span>
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="paymentRefused">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.paymentRefused' | ibeadmin | async}}">
                <div message>
                    {{'shoppingBasket.text.tryAgainOrSelectOther' | ibeadmin | async}}
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="alertErrorPayment">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{('shoppingBasket.title.alertErrorPaymentWith' | ibeadmin | async) + ' ' + (selectedPaymentMethodTranslationKey | ibeadmin | async) }}">
                <div message>
                    {{'shoppingBasket.text.tryAgainOrSelectOther' | ibeadmin | async}}
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="alertErrorPaymentresultFCE">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.alertErrorPaymentresultFCE' | ibeadmin | async}}">
                <div message>
                    {{'shoppingBasket.text.tryAgainOrSelectOther' | ibeadmin | async}}
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="alertErrorPaymentresultCyberSourceReject">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.alertErrorPaymentresultCyberSourceReject' | ibeadmin | async}}">
                <div message>
                    {{'shoppingBasket.text.tryAgainOrSelectOther' | ibeadmin | async}}
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="hasVoucherErrorFlag1">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.alertErrorVoucher1' | ibeadmin | async}}">
                <div message>
                    {{'shoppingBasket.text.alertErrorVoucher1' | ibeadmin | async}}
                </div>
            </app-notification>
        </ng-container>

        <ng-container *ngIf="hasVoucherErrorFlag2">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.alertErrorVoucher2' | ibeadmin | async}}">
                <div message>
                    <span>{{'shoppingBasket.text.alertErrorVoucher2A' | ibeadmin | async}}</span><br />
                    <span>{{'shoppingBasket.text.alertErrorVoucher2B' | ibeadmin | async}}</span>
                </div>
            </app-notification>
        </ng-container>


        <ng-container *ngIf="notificationCybersource">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.notificationCybersource' | ibeadmin | async}}">
            </app-notification>
        </ng-container>

        <ng-container *ngIf="hasPaybyrdError">
            <app-notification [classes]="'top-gap'" [style]="'error'" title="{{'shoppingBasket.title.paymentRefused' | ibeadmin | async}}">
                <div message>
                    {{ paybyrdErrorMsg }}
                </div>
            </app-notification>
        </ng-container>

        <!-- Payment component -->
        <app-payment *ngIf="showPaymentForm && !paymentFormLoading && !INDRA_isZeroCashPayment() && !isPaybyrdEnabled && !adyenPopUpEnabled" [availablePaymentMethods]="marketPaymentMethods" [disabledPaymentMethods]="disabledPaymentMethods" [disabledTooltipMessage]="disabledTooltipMessage" [hasMilesPayable]="INDRA_hasMilesPayable()"
            [displayCovidTermsAndCondition]="isCanadaFlight">
        </app-payment>

        <ng-container *ngIf="isPaybyrdEnabled || adyenPopUpEnabled">
      <div class="payment-option__conditions-wrapper" [ngClass]="{'has-error': !acceptedTermsAndConditions && submitted}">
                <div class="payment-conditions">
                    <app-checkbox-input (change)="INDRA_acceptTermsAndConditionsChange($event)" label="" [class.has-error]="!acceptedTermsAndConditions && submitted"></app-checkbox-input>
                    <span>
                        {{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
                        <a class="text-link" href="javascript:;" (click)="INDRA_handleBookingTicketConditions()" 
                            attr.aria-label="{{'bookingPayment.aria.openFare' | ibeadmin | async}}" role="button">
                            {{'bookingPayment.text.fareConditions' | ibeadmin | async}}
                        </a> 
                        {{'bookingPayment.text.andThe' | ibeadmin | async}} 
                        <a class="text-link link--external" href="javascript:;"
                            (click)="INDRA_gotoURL('externalURLs.transportConditions')"
                            attr.aria-label="{{'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async}}">
                            {{'bookingPayment.text.tncCarriage' | ibeadmin | async}}
                        </a> 
                        <!--{{'bookingPayment.text.andThe' | ibeadmin | async}}
                        <a class="link link--external" href="javascript:;"
                            (click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
                            {{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
                        </a>-->
                        <ng-container *ngIf="displayCovidTermsAndCondition">
                            , {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
                            <a class="text-link link--external" href="javascript:;"
                                (click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
                                {{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
                            </a>
                            {{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
                        </ng-container>
                    </span>
                </div>
                <hr class="separator separator--muted" aria-hidden="true">
                <div class="payment-caution-box">
                    <span class="payment-caution-message">
                        {{ 'bookingPayment.text.paybyrdWarning' | ibeadmin | async }}
                    </span>
                </div>
            </div>
        </ng-container>
        <!-- <button type="button" (click)="INDRA_redirectTo3()">Modal</button> -->

    </section>
</section>

<ng-container *ngIf="differentTTTMarket && (this.INDRA_getCurrentStep() == 4) && arePaymentMethodsLoaded">
    <div class="container">
        <app-notification [classes]="'top-gap'" [style]="'alert'" [icon]="'icons.svg#airport--delays'" title="">
            <div message>
                {{'bookingDetails.text.TTTMarketNotSame' | ibeadmin | async}}
            </div>
        </app-notification>
    </div>
</ng-container>

<hr class="separator separator--muted" aria-hidden="true" *ngIf="!INDRA_isZeroCashPayment() && !isPaybyrdEnabled && !adyenPopUpEnabled">

<!-- for Non-Zero Payment -->
<section class="align-right payment-bottom-summary__wrapper" *ngIf="INDRA_getStatusStep(3).status && !INDRA_isDUPE() && !INDRA_haveFlighPricesChanged() && arePaymentMethodsLoaded && !hasPaymentStepError && !INDRA_isZeroCashPayment() && !isPaybyrdEnabled && !adyenPopUpEnabled">

    <div class="container">
        <div class="grid no-padding">
             <!-- <div class="col-12 col-tp-12 col-p-12">
                <h4 class="title-h4 title-confirmation no-margin align-right">
                    <ng-container *ngIf="isBookingPaymentPage">
                        <span class="color-green" *ngIf="totalFlightPrice && totalFlightPrice.miles">
							{{ totalFlightPrice.miles | indracurrency: 'M' }} +
						</span> {{ INDRA_printTotalPrice() | indracurrency }}
                    </ng-container>
                    <ng-container *ngIf="isTTTPaymentPage">
                        {{ INDRA_printTotalPrice() | indracurrency }}
                    </ng-container>
                </h4>
            </div>

            <div class="col-12 col-tp-12 col-p-12 payment-bottom-confirmation__wrapper top-gap">
                <button #buttonHandlePay *ngIf="selectedPaymentMethod != 'paypal' || storedOCPPaypal" class="button button-accent button--icon-right button--mobile-full" (click)="INDRA_confirmPayment()" [disabled]="!formIsValid" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
					{{'bookingPayment.text.confirmBooking' | ibeadmin | async}}
					<app-svg svg="icons.svg#general--arrow--right" [alt]="'Arrow icon'" aria-hidden=true></app-svg>
				</button>

                <ng-container *ngIf="selectedPaymentMethod == 'paypal' && !storedOCPPaypal">
                    <app-paypal-payment [promoCodesAndVoucher]="promoCodesAndVoucher" (emitLoader)="overlayLoaderEvent($event)" (emitVoucherError)="INDRA_errorRedeemVoucherPaypal($event)"></app-paypal-payment>
                </ng-container>

                <div class="card-secure-logos__wrapper" *ngIf="(selectedPaymentMethod === 'credit_card' || selectedPaymentMethod === 'debit_card')">
                    <app-svg class="card-secure-logo" svg="sprite.svg#logo--visa_secure" [alt]="'Visa Secure logo'"></app-svg>
                    <app-svg class="card-secure-logo not-first" svg="sprite.svg#logo--mastercard_id_check" [alt]="'Visa Secure logo'"></app-svg>
                    <app-svg *ngIf="market === 'FR'" class="card-secure-logo not-first" svg="sprite.svg#credit_card--carte_bleue" [alt]="'Cartes Bancaries logo'"></app-svg>
                </div>
            </div> -->

            <div class="col-12 col-tp-12 col-p-12 align-left--mobile top-gap" *ngIf="!formIsValid">
                <span class="muted" aria-live="polite">
					{{'bookingPayment.text.pleaseInsertAllInfo' | ibeadmin | async}}
				</span>
            </div>
            <div class="col-12 col-tp-12 col-p-12 align-left--mobile top-gap">
                <span class="muted" aria-live="polite">
					{{'bookingPayment.text.paymentWarning' | ibeadmin | async}}
				</span>
            </div>
        </div>
    </div>
</section>

<!-- for adyen Payment -->
<!-- <section class="align-center payment-bottom-summary__wrapper" *ngIf="INDRA_getStatusStep(3).status && !INDRA_isDUPE() && !INDRA_haveFlighPricesChanged() && arePaymentMethodsLoaded && !hasPaymentStepError && !INDRA_isZeroCashPayment() && !isPaybyrdEnabled && adyenPopUpEnabled">
    <button class="button button-accent button--big button--fat button--mobile-full bottom-gap" (click)="INDRA_adyenCheckOut()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async" [disabled]="!isButtonPaybyrdEnabled">
            {{'bookingPayment.text.confirmBooking' | ibeadmin | async}}
    </button>
</section> -->

<!-- for paybyrd Payment -->
<!-- <section class="align-center payment-bottom-summary__wrapper" *ngIf="INDRA_getStatusStep(3).status && !INDRA_isDUPE() && !INDRA_haveFlighPricesChanged() && arePaymentMethodsLoaded && !hasPaymentStepError && !INDRA_isZeroCashPayment() && isPaybyrdEnabled">
        <button class="button button-accent button--big button--fat button--mobile-full bottom-gap" (click)="INDRA_paybyrdCheckOut()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async" [disabled]="!isButtonPaybyrdEnabled">
				{{'bookingPayment.text.confirmBooking' | ibeadmin | async}}
		</button>
</section> -->


<!-- for Zero Payment -->
<section class="align-right payment-bottom-summary__wrapper" *ngIf="INDRA_getStatusStep(3).status && !INDRA_isDUPE() && !INDRA_haveFlighPricesChanged() && arePaymentMethodsLoaded && !hasPaymentStepError && INDRA_isZeroCashPayment()">
    <div class="container">
        <div class="grid no-padding">
            <!-- <div class="col-12 col-tp-12 col-p-12 payment-bottom-confirmation__wrapper">
                <button #buttonHandlePay class="button button-accent button--icon-right button--mobile-full" (click)="INDRA_confirmZeroPayment()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
					{{'bookingPayment.text.confirmBooking' | ibeadmin | async}}
					<app-svg svg="icons.svg#general--arrow--right" [alt]="'Arrow icon'" aria-hidden=true></app-svg>
				</button>
            </div> -->
            <div class="col-12 col-tp-12 col-p-12 align-left--mobile top-gap">
                <span class="muted" aria-live="polite">
					{{'bookingPayment.text.paymentWarning' | ibeadmin | async}}
				</span>
            </div>
        </div>
    </div>
</section>

<div class="payment_loader_container__overlay" *ngIf="paymentLoading">
    <div class="loading-wrapper">
        <app-loading></app-loading>
    </div>
</div>

<div class="payment_loader_container__overlay" *ngIf="paymentLoadingPaybyrd">
    <div class="loading-wrapper">

        <div class="slideshow__close" (click)="INDRA_onCancelPaybyrd()">
            <app-svg svg="icons.svg#general--close" [alt]="'Close icon'" aria-hidden="true"></app-svg>
        </div>
        <app-paybyrdLoading>
        </app-paybyrdLoading>
    </div>
</div>

<!-- applicable only when in step 4 -->
<ng-container *ngIf="INDRA_getStatusStep(3).status && !INDRA_isDUPE() && !INDRA_haveFlighPricesChanged() && arePaymentMethodsLoaded && !isPaybyrdEnabled && !adyenPopUpEnabled">
    <section class="container payment-method-section" *ngIf="encodedcReq">
        <form method="POST" action="{{threeDSMethodURLShopper}}" id="3dschallenge" target="Payment_shopper" name="3dschallenge">
            <input type="hidden" name="creq" value="{{encodedcReq}}" />
        </form>

        <!-- Iframe Challenge Shopper -->
        <iframe id="Payment_shopper" name="Payment_shopper" height="600px" width="100%" style="position: relative; z-index: 200"></iframe>
    </section>

    <section class="container payment-method-section" *ngIf="encodedJSON">
        <form method="POST" action="{{threeDSMethodURL}}" id="3dform" target="Payment_IdentifyShopper" name='3dform'>
            <input type="hidden" name="threeDSMethodData" value="{{encodedJSON}}" />
        </form>

        <!-- Iframe Identify Shopper -->
        <iframe id="iframeIdentifyShopper" name="Payment_IdentifyShopper" style="visibility: hidden">
		</iframe>
    </section>

    <section class="container payment-method-section">
        <form method="POST" action="{{threeDSMethodRedirectShopperURL}}" id="3dformRedirect" name="3dformRedirect">
            <input type="hidden" name="PaReq" value="{{paReq}}" />
            <input type="hidden" name="MD" value="{{md}}" />
            <input type="hidden" name="TermUrl" value="{{termUrl}}" />
            <noscript>
				<br>
				<br>
				<div style="text-align: center">
					<h1>{{'bookingPayment.text.processing3d' | ibeadmin | async}}</h1>
					<p>{{'bookingPayment.text.clickContinue3d' | ibeadmin | async}}</p>
					<input type="submit" class="button" value="continue" />
				</div>
			</noscript>
        </form>
    </section>

    <ng-container *ngIf="urlSafe">
        <noscript>
			<iframe style="width: 100px; height: 100px; border: 0; position: absolute; top: -5000px;" [src]= "urlSafe"></iframe>
		</noscript>
    </ng-container>
</ng-container>
